import { useState } from "react";
import { Paper, Tab, Tabs } from "@mui/material";
import { PromotionReservationsPanel } from "../../../listings";
import SiteSliders from "./SiteSliders";

export default function Sliders() {
  const [tab, setTab] = useState("site");
  return <>
    <Paper variant="outlined" className="md:mx-3 mx-1 mb-3">
      <Tabs value={tab} onChange={(_, next) => setTab(next)} aria-label="مدیریت اسلایدر">
        <Tab value="site" label="بنرهای دیجیکرام" /><Tab value="customers" label="بنرهای تبلیغاتی" />
      </Tabs>
    </Paper>
    {tab === "site" ? <SiteSliders /> : <PromotionReservationsPanel bannersOnly />}
  </>;
}
